import React from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { UploadFile } from '@mui/icons-material';
import { DropWrapper, DropZone } from 'components/dropZone/components';


type DropCustomProps = {
    title: string;
    options?: DropzoneOptions,
    compact?: boolean,
}

const DropCustom = ({title, options, compact = false}: DropCustomProps) => {
    const {t} = useTranslation();

    const {getRootProps, getInputProps, isDragActive} = useDropzone(options);

    return (
        <DropWrapper>
            <DropZone {...getRootProps({className: 'drop-image'})}>
                <input {...getInputProps()} />
                <div className={`title ${compact ? 'compact' : ''}`}><UploadFile/><br/>{title}</div>
                {isDragActive &&
                    <div className="drop-here">{t('drop_files_here')}...</div>
                }
            </DropZone>
        </DropWrapper>
    )
}

export default DropCustom;
